"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormRow;
function FormRow(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? 'form-row' : _props$className,
    _props$errorClass = props.errorClass,
    errorClass = _props$errorClass === void 0 ? 'form-row--has-errors' : _props$errorClass,
    _props$hasErrors = props.hasErrors,
    hasErrors = _props$hasErrors === void 0 ? false : _props$hasErrors,
    children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: hasErrors ? "".concat(className, " ").concat(errorClass) : className
  }, children);
}